<section class="expense-list-wrapper">
  <div class="message error" *ngIf="!isAuthenticated">Please log in first.</div>

  <section *ngIf="isAuthenticated">
    <div class="message info" *ngIf="isLoading">{{ status }}</div>
    <div class="message error" *ngIf="error">{{ error }}</div>

    <app-entity-list
      *ngIf="!error"
      [loading]="isLoading"
      [list]="expenseList"
      [deletedMode]="deletedMode"
      [showMenuInDeletedMode]="deletedMode"
      [tableHeaderAndValueKeySets]="tableHeaderAndValueKeySets"
      [emptyMessage]="'No expense found.'"
      [menuActions]="expenseMenuActions"
      (cardClick)="onCardClickFromList($event)"
      (editClick)="onEditClickFromList($event)"
      (deleteClick)="onDeleteClickFromList($event)"
      (menuAction)="onMenuAction($event)"
      (loadMore)="onLoadMoreFromList()"
    ></app-entity-list>
  </section>

  <div class="modal-overlay" *ngIf="isDetailsOpen && selectedExpense" (click)="closeDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeDetailsModal()">&times;</button>
      <h3>Expense Details</h3>

      <div class="details-grid">
        <div class="details-item">
          <span class="label">Transaction No</span>
          <span class="value">{{ selectedExpense.txnNo || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">House</span>
          <span class="value">{{ houseLabel(selectedExpense) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Flat</span>
          <span class="value">{{ selectedExpense.flat?.flatName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Floor</span>
          <span class="value">{{ selectedExpense.flat?.floorName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Expense Head</span>
          <span class="value">{{ selectedExpense.expenseHead?.name || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Expense Month</span>
          <span class="value">{{ expenseMonthLabel(selectedExpense.expenseMonth, selectedExpense.expenseYear) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Expense Date</span>
          <span class="value">{{ formatDate(selectedExpense.expenseDate) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Amount</span>
          <span class="value">{{ selectedExpense.expenseAmount || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Status</span>
          <span class="value">{{ selectedExpense.status === 1 ? 'Active' : 'Inactive' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created On</span>
          <span class="value">{{ formatDateTime(selectedExpense.createdOn) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created By</span>
          <span class="value">{{ actorLabel(selectedExpense.createdByUser, selectedExpense.createdBy) }}</span>
        </div>
        <div class="details-item" *ngIf="hasRecordedUpdate(selectedExpense)">
          <span class="label">Updated On</span>
          <span class="value">{{ formatDateTime(selectedExpense.updatedOn) }}</span>
        </div>
        <div class="details-item" *ngIf="hasRecordedUpdate(selectedExpense) && hasUpdatedActor(selectedExpense)">
          <span class="label">Updated By</span>
          <span class="value">{{ actorLabel(selectedExpense.updatedByUser, selectedExpense.updatedBy) }}</span>
        </div>
        <div class="details-item details-item-full" *ngIf="selectedExpense.remarks">
          <span class="label">Remarks</span>
          <span class="value">{{ selectedExpense.remarks }}</span>
        </div>
      </div>

      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeDetailsModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isHistoryOpen && selectedExpense" (click)="closeHistoryModal()">
    <div class="details-modal history-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeHistoryModal()">&times;</button>
      <h3>Expense History</h3>
      <div class="history-subtitle">
        {{ selectedExpense.expenseHead?.name || 'N/A' }} | Txn {{ selectedExpense.txnNo || 'N/A' }}
      </div>

      <div class="history-list" *ngIf="selectedExpenseHistory.length > 0; else emptyHistory">
        <div class="history-header">
          <span>Recorded On</span>
          <span>By</span>
          <span>Month</span>
          <span>Head</span>
          <span>Amount</span>
          <span>Remarks</span>
        </div>
        <div class="history-card" *ngFor="let history of selectedExpenseHistory" (click)="openHistoryDetails(history)">
          <span>{{ formatDateTime(history.createdOn) }}</span>
          <span class="history-actor">{{ historyByLabel(history) }}</span>
          <span>{{ expenseMonthLabel(history.expenseMonth, history.expenseYear) }}</span>
          <span>{{ history.expenseHead?.name || selectedExpense.expenseHead?.name || 'N/A' }}</span>
          <span>{{ history.expenseAmount || 0 }}</span>
          <span class="history-remarks">{{ history.remarks || 'N/A' }}</span>
        </div>
      </div>

      <ng-template #emptyHistory>
        <div class="message info">No history found.</div>
      </ng-template>

      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeHistoryModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isHistoryDetailsOpen && selectedHistoryItem" (click)="closeHistoryDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeHistoryDetailsModal()">&times;</button>
      <h3>History Details</h3>

      <div class="details-grid">
        <div class="details-item">
          <span class="label">Transaction No</span>
          <span class="value">{{ selectedHistoryItem.txnNo || selectedExpense?.txnNo || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Expense Head</span>
          <span class="value">{{ selectedHistoryItem.expenseHead?.name || selectedExpense?.expenseHead?.name || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Expense Month</span>
          <span class="value">{{ expenseMonthLabel(selectedHistoryItem.expenseMonth, selectedHistoryItem.expenseYear) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Expense Date</span>
          <span class="value">{{ formatDate(selectedHistoryItem.expenseDate) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Amount</span>
          <span class="value">{{ selectedHistoryItem.expenseAmount || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Status</span>
          <span class="value">{{ selectedHistoryItem.status === 1 ? 'Active' : 'Inactive' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Recorded On</span>
          <span class="value">{{ formatDateTime(selectedHistoryItem.createdOn) }}</span>
        </div>
        <div class="details-item" *ngIf="hasUpdatedActor(selectedHistoryItem)">
          <span class="label">Updated By</span>
          <span class="value">{{ actorLabel(selectedHistoryItem.updatedByUser, selectedHistoryItem.updatedBy) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created By</span>
          <span class="value">{{ actorLabel(selectedHistoryItem.createdByUser, selectedHistoryItem.createdBy) }}</span>
        </div>
        <div class="details-item details-item-full">
          <span class="label">Remarks</span>
          <span class="value">{{ selectedHistoryItem.remarks || 'N/A' }}</span>
        </div>
      </div>

      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeHistoryDetailsModal()">Close</button>
      </div>
    </div>
  </div>

  <app-new-edit-expense
    *ngIf="isEditOpen"
    [mode]="selectedExpense ? 'edit' : 'create'"
    [initialExpense]="selectedExpense"
    (close)="closeEditModal()"
    (save)="onEditSave()"
  ></app-new-edit-expense>

  <app-confirm-action-modal
    [visible]="!!pendingDeleteExpense"
    [title]="'expense.deleteTitle' | t:'Delete Expense'"
    [message]="'expense.deleteMessage' | t:'Delete this expense?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [isLoading]="isDeleting"
    [danger]="true"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDeleteExpense()"
  ></app-confirm-action-modal>
</section>
